module.exports = __webpack_public_path__ + "img/plasticproducts_icon.ca16b60b.svg";